import { useToast } from "@/hooks/use-toast";
import { playClickSound } from "@/lib/clickSound";

interface CopyableCodeProps {
  text: string;
  className?: string;
}

// Inline <code> that copies itself to the clipboard on click — a small
// click sound plus a toast confirm it landed, since there's no other
// visual feedback on a bare inline code snippet otherwise.
const CopyableCode = ({ text, className = "" }: CopyableCodeProps) => {
  const { toast } = useToast();

  const copy = () => {
    navigator.clipboard.writeText(text);
    playClickSound();
    toast({ title: "Copied!", description: "On your clipboard — paste it wherever you need it." });
  };

  return (
    <code
      onClick={copy}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); copy(); } }}
      title="Click to copy"
      className={`cursor-pointer select-all hover:bg-accent/20 hover:text-accent transition-colors ${className}`}
    >
      {text}
    </code>
  );
};

export default CopyableCode;
